import { createSlice } from "@reduxjs/toolkit";
import { getBusinessCategoryList } from "./ThunkAction";
import { iBusinessCategoryState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iBusinessCategoryState = {
  isLoading: false,
  businessCategoryList:[],
  errorMessage: null,
};
export const businessCategorySlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetBusinessCategoryState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getBusinessCategoryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBusinessCategoryList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.businessCategoryList = payload.data; 
          state.isLoading = false;
        }
      })
      .addCase(getBusinessCategoryList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Attribute data";
        state.isLoading = false;
      });
  },
});

export const { resetBusinessCategoryState } = businessCategorySlice.actions;
export default businessCategorySlice.reducer;
